import { render } from "./PermissionCreate.vue?vue&type=template&id=55b7195c"
import script from "./PermissionCreate.vue?vue&type=script&lang=js"
export * from "./PermissionCreate.vue?vue&type=script&lang=js"
script.render = render

export default script